export const TagIcon = () => (
  <svg
    className="tag-icon"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.792 11.496L12.992 0.696C12.56 0.264 11.96 0 11.3 0H2.9C1.58 0 0.5 1.08 0.5 2.4V10.8C0.5 11.46 0.764 12.06 1.208 12.504L12.008 23.304C12.44 23.736 13.04 24 13.7 24C14.36 24 14.96 23.736 15.392 23.292L23.792 14.892C24.236 14.46 24.5 13.86 24.5 13.2C24.5 12.54 24.224 11.928 23.792 11.496ZM4.7 6C3.704 6 2.9 5.196 2.9 4.2C2.9 3.204 3.704 2.4 4.7 2.4C5.696 2.4 6.5 3.204 6.5 4.2C6.5 5.196 5.696 6 4.7 6Z"
      fill="currentColor"
    />
  </svg>
);
